import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ProviderPage } from "@/features/provider-workspace/provider-page/provider-page";
import {
  providerPageSearchSchema,
  type ProviderPageSearch,
} from "@/features/provider-workspace/provider-page/provider-page-search";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/providers/credentials/$affiliationId/",
)({
  validateSearch: providerPageSearchSchema,
  component: ProviderPageRoute,
});

function ProviderPageRoute() {
  const { organizationBusinessUnitId, affiliationId } = Route.useParams();
  const search = Route.useSearch();
  const { organizations } = Route.useRouteContext();
  const navigate = Route.useNavigate();
  const businessUnitName = organizations
    ?.flatMap((organization) => organization.businessUnits)
    .find(
      (businessUnit) => businessUnit.id === organizationBusinessUnitId,
    )?.name;
  const onSearchChange = useCallback(
    (changes: Partial<ProviderPageSearch>) => {
      void navigate({
        search: (previous) => ({ ...previous, ...changes }),
        replace: true,
      });
    },
    [navigate],
  );
  return (
    <ProviderPage
      organizationBusinessUnitId={organizationBusinessUnitId}
      affiliationId={affiliationId}
      businessUnitName={businessUnitName}
      search={search}
      onSearchChange={onSearchChange}
    />
  );
}
